import React from 'react';

const UserAvatar = ({ avatar, style, size, fontSize }) =>
	avatar ? (
		avatar.image ? (
			<img
				className={`${!avatar.square ? 'user-avatar rounded-circle ' : ''}size-${size || 50} ${style}`}
				alt={avatar.initials}
				src={avatar.image}
			/>
		) : (
			<span className={`user-avatar bg-blue border-0 size-${size || 50} ${style}`}>
				<h3 className="m-0 text-white text-uppercase" style={fontSize ? { fontSize } : {}}>
					{avatar.initials}
				</h3>
			</span>
		)
	) : (
		<span className={`user-avatar bg-blue border-0 size-${size || 50} ${style}`}>
			<h3 className="m-0 text-white" style={fontSize ? { fontSize } : {}} />
		</span>
	);

export default UserAvatar;



// WEBPACK FOOTER //
// ./components/UserAvatar.js